import { render, staticRenderFns } from "./projectOrderRecover.vue?vue&type=template&id=0b070b02&scoped=true"
import script from "./projectOrderRecover.vue?vue&type=script&lang=js"
export * from "./projectOrderRecover.vue?vue&type=script&lang=js"
import style0 from "./projectOrderRecover.vue?vue&type=style&index=0&id=0b070b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b070b02",
  null
  
)

export default component.exports